import React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import {


  Paper,
} from '@mui/material'
import { makeStyles, createStyles, withStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

interface TableOtInboundProps  {
    SupplierOriginName: string,
    UnitsQty: number,
    WorkOrderId: number,
    FEFO: boolean,
    SkuQty: number,
    SkuPriorityQty: number,
    UnitsPriorityQty: number
}

const useStyles = makeStyles({
    table: {},
    box: {
      height: 100,
      display: 'flex'
    },
    centerBox: {
      justifyContent: 'flex-end',
      alignItems: 'flex-end'
    }
  })

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.grey[400],
      color: theme.palette.grey[800]
    },
    body: {
      fontSize: 14
    }
  })
)(TableCell)

export const TableOtInbound = (
  {
  SupplierOriginName,
  UnitsQty,
  WorkOrderId,
  FEFO,
  SkuQty ,
  SkuPriorityQty,
  UnitsPriorityQty
  }
  :TableOtInboundProps) => {

    const classes = useStyles();

    return (
        <TableContainer component={Paper}>
        <Table className={classes.table} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <StyledTableCell align='center'>Origen</StyledTableCell>
              <StyledTableCell align='center'>Unidades totales</StyledTableCell>
              <StyledTableCell align='center'>FEFO</StyledTableCell>
              <StyledTableCell align='center'>SKU totales</StyledTableCell>
              <StyledTableCell align='center'>SKU priorizados</StyledTableCell>
              <StyledTableCell align='center'>Unidades priorizadas</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow key={WorkOrderId}>
              <TableCell style={{textAlign: 'center'}}>{SupplierOriginName}</TableCell>
              <TableCell style={{textAlign: 'center'}}>{UnitsQty}</TableCell>
              <TableCell align='center' component='th' scope='row'>
                {FEFO ? 'Sí' : 'No'}
                </TableCell>
              <TableCell align='center'>{SkuQty}</TableCell>
              <TableCell align='center'>{SkuPriorityQty}</TableCell>
              <TableCell align='center'>{UnitsPriorityQty}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    )
}
